import script from "./TokenClose.vue?vue&type=script&setup=true&lang=js"
export * from "./TokenClose.vue?vue&type=script&setup=true&lang=js"

import "./TokenClose.vue?vue&type=style&index=0&id=a9c3a21e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9c3a21e"]])

export default __exports__